import {
  BarChart3,
  Bell,
  ClipboardList,
  Package,
  Settings2,
  Star,
  Tag,
  Users,
  UtensilsCrossed,
  Wallet,
  type LucideIcon,
} from 'lucide-react';
import type { MerchantNavItem } from './merchantNav.js';

const BY_ICON: Record<MerchantNavItem['icon'], LucideIcon> = {
  orders: ClipboardList,
  catalogue: UtensilsCrossed,
  inventory: Package,
  promotions: Tag,
  finance: Wallet,
  reports: BarChart3,
  reviews: Star,
  team: Users,
  settings: Settings2,
};

export function MerchantNavIcon({
  icon,
  size = 18,
}: {
  icon: MerchantNavItem['icon'];
  size?: number;
}) {
  const Cmp = BY_ICON[icon];
  return <Cmp size={size} aria-hidden />;
}

export function MerchantBellIcon({ size = 18 }: { size?: number }) {
  return <Bell size={size} aria-hidden />;
}
